<template>
  <DashboardTemplate :navMenu="true" class="custom-activity">
    <div class="pd-b-5 flex-display js-between change-display">
      <div class="text-left">
        <h2 class="mg-less">งานที่ได้รับมอบหมาย (Assignment)</h2>
        <div class="flex-display">
          <p class="text-font-14">
            <span class="text-weight-bold">หลักสูตร </span
            ><span class="color-gray">{{ course.name }}</span>
          </p>
          <p class="text-font-14 pd-l-4"> <span class="text-weight-bold">วิชาที่</span> {{subject.index}} <span class="color-gray">{{ subject.name }}</span></p>
        </div>
        
      </div>
    </div>
    
    <div v-loading="loading">
      <AssignmentList
          @fetchSubjectId="fetchSubjectId"
          :assignmentList="assignmentList"
          :courseId="courseId"
          :subjectId="subjectId"
      />
    </div>

    <div v-if="assignmentListConst.length > 10" class="pd-y-3">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="assignmentListConst.length"
        :page-size="pageSize"
        :current-page="page"
      ></el-pagination>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import AssignmentList from "@/components/assignment/AssignmentList";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  components: {
    DashboardTemplate,
    AssignmentList,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
    assignmentList() {
      return this.assignmentListConst.slice((this.page-1)*this.pageSize, this.page*this.pageSize);
    },
  },
  data() {
    return {
      loading:true,
      courseId: "",
      subjectId: "",
      assignmentListConst: [],
      course: "",
      subject: "",
      page: 1,
      pageSize: 10,
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchSubjectId();
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      let filter = this.courseList.filter(
        (filter) => filter._id == this.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
          this.subjectId = this.routeParams.subjectId;
          if (typeof this.routeParams.tab != "undefined") {
            this.activeName = this.routeParams.tab
          }
        }
      }
    },
    fetchSubjectId() {
      let obj = {
        subjectId: this.subjectId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/subject`, obj)
        .then((res) => {
          if (res.data.success) {
            this.assignmentListConst = res.data.obj.assignment;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchSubjectId error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    changePage(page) {
      this.page = page;
    },
    changeTab() {
      this.page = 1;
    },
  },
};
</script>